import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Nav, NavItem, NavLink } from 'reactstrap';
import { useIntl } from 'react-intl';

const PageDetailsTabs = ({ activeTab, handleSwitchTab }) => {
  const intl = useIntl();

  return (
    <Nav tabs className="settings-tabs">
      <NavItem>
        <NavLink
          className={classnames({ active: activeTab === 'collected-details' })}
          onClick={() => { handleSwitchTab('collected-details'); }}
        >
          {intl.formatMessage({ defaultMessage: 'Collected details' })}
        </NavLink>
      </NavItem>
    </Nav>
  );
};

PageDetailsTabs.propTypes = {
  activeTab: PropTypes.string.isRequired,
  handleSwitchTab: PropTypes.func.isRequired,
};

export default PageDetailsTabs;
